<mat-table [dataSource]="dataSub" matSort aria-label="Expenditure List">
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; index as i" class="header-cell">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnConfig[i].label }}</mat-header-cell>
    <mat-cell *matCellDef="let cell; index as j" [class.is-linkable]="columnConfig[i].linkable">
      @if (columnConfig[i].key !== 'createdDate' 
           && columnConfig[i].key !== 'dueDate' 
           && columnConfig[i].key !== 'recordNumber') {
        <ng-container>
          {{ cell[column] }}
        </ng-container>
      }

      @if (columnConfig[i].key === 'firstName') {
        <ng-container>
          {{ cell[column] }}
        </ng-container>
      }

      @if (columnConfig[i].key === 'createdDate') {
        <ng-container>
          <!--{{ cell[column] | date: 'd-MMM-y' | uppercase }}-->
          {{ cell[column] | date: 'y-MM-dd' }} <!-- ISO-8601 date format -->
        </ng-container>
      }

      @if (columnConfig[i].key === 'dueDate') {
        <ng-container>
          <span [class.due]="ltCurrDate(cell[column])">
              <!--{{ cell[column] | date: 'd-MMM-y' | uppercase }}-->
            {{ cell[column] | date: 'y-MM-dd' }} <!-- ISO-8601 date format -->
          </span>
        </ng-container>
      }
      
      @if (columnConfig[i].key === 'recordNumber') {
        <ng-container>
          <a (click)="refNavigate(cell)">{{ cell[column] }}</a>
        </ng-container>
      }
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let cell; columns: columns"></mat-row>
</mat-table>

<!-- No data found -->
<ng-container *transloco="let t">
  @if (isReady && resultCount < 1) {
    <ng-container>
      <div class="noresult">
        <div class="center">
          <center>
            <div style="margin-block: 3%">
              {{ t('NoResultsFound') }}
            </div>
          </center>
        </div>
      </div>
    </ng-container>
  }
</ng-container>